"use client";
import { createContext, useContext } from "react";

type ToastVariant = "success" | "danger" | "info" | "warning";

interface ToastMessage {
    id: number;
    message: string;
    variant?: ToastVariant;
    delay?: number;
    title?: string;
}

interface ToastContextType {
    show: (toast: Omit<ToastMessage, "id">) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error("useToast must be used within a ToastProvider");
    return ctx;
}

export default ToastContext;
